import { Box } from '@chakra-ui/react'
import { FC } from 'react'

const MarkdownTable: FC = (props) => {
  return <Box as="table" border="1px solid" borderColor="gray.100" {...props} />
}

export default MarkdownTable
